<template>
  <div class="signin">
    <div v-if="!signedIn">
      <amplify-authenticator v-bind:authConfig="authConfig">
      </amplify-authenticator>
      <!--<amplify-google-button @click="signinByGoogle"></amplify-google-button>-->
       <el-button type="warning" @click="signinByGoogle">Googleでサインイン</el-button>
       <p>test</p>
    </div>
  </div>
</template>
<script>
  import { Auth, Hub } from 'aws-amplify';
  import { AmplifyEventBus } from 'aws-amplify-vue';
  import store from '@/store/index.js';

  export default {
    name: 'SignIn',
    data() {
      return {
        signedIn: false,
        authConfig: {
          signUpConfig: {
            hideAllDefaults: true,
            defaultCountryCode: '1',
            signUpFields: [{
                label: 'Username',
                key: 'username',
                required: true,
                displayOrder: 1,
                type: 'string',
              },
              {
                label: 'Password',
                key: 'password',
                required: true,
                displayOrder: 2,
                type: 'password'
              },
            ]
          }
        }
      };
    },
    computed: {
      user() {
        return store.state.user;
      }
    },
    async beforeCreate() {
      try {
        await Auth.currentAuthenticatedUser();
        this.signedIn = true;
      }
      catch (err) {
        this.signedIn = false;
      }

      let parantExistanceFlag = true;

      if (!window.opener || !Object.keys(window.opener).length) {
        window.alert('親画面が存在しません')
        parantExistanceFlag = false
      }

      if (this.user) {
        window.opener.location.reload();
        window.close();
      }

      AmplifyEventBus.$on('authState', async info => {
        if (info === 'signedIn') {
          // this.$router.push({ name: 'Home' });
          if (parantExistanceFlag) {
            window.opener.location.reload();
            window.close();
          }
        }
        else {
          this.signedIn = false;
        }
      });


      //TODO: サインイン後の挙動は要検討&修正
      Hub.listen("auth", async(data) => {
        switch (data.payload.event) {
          case "signIn":
            { // サインインイベントをフック
              const cognitoUser = await Auth.currentAuthenticatedUser();
              console.log(`signed in ... ${cognitoUser.username}`);
              // this.$store.dispatch("signedIn", true);
              // this.$store.dispatch("loading", false); //処理中表示（処理終了）
              // Swal.fire({ // ダイアログ表示
              //   position: "top-end",
              //   icon: "success",
              //   title: "ログインしました",
              //   showConfirmButton: false,
              //   timer: 1500,
              // });
              store.commit('setUser', data);
              this.signedIn = true;
              if (parantExistanceFlag) {
                
                //TODO: リダイレクトされるため親ウィンドウを閉じれなくなるので修正
                window.opener.location.reload();
                window.close();
              }
              break;
            }
          default:
            break;
        }
      });

    },
    methods: {
      signinByGoogle: async function() {
        const res = await Auth.federatedSignIn({ provider: 'Google' });
        console.log(res);
      }
    }
  };
</script>
<style>
  .signin {
    margin: 20px;
    text-align: center;
  }

  input {
    font-size: 16px !important;
  }

  @media screen and (max-width: 480px) {
    .signin div {
      min-width: 0;
    }
  }
</style>
